import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import AttachmentUpload from 'components/AttachmentUpload'
import { selectTicketDraftAttachments } from 'selectors/attachments'
import { getLength } from 'util/arrays'
import IconWithTooltip from './IconWithTooltip'

class AttachmentIcon extends React.Component {
  openAttachmentDialog = () => {
    document.getElementById(this.props.triggerId).click()
  }

  render() {
    const {
      dispatch,
      forNote,
      hasAttachments,
      triggerId,
      icon,
      ...rest
    } = this.props

    const tooltipProps = {
      tooltip: 'Add attachments',
      position: 'top',
    }
    const Icon = icon ? (
      React.cloneElement(icon, { withTooltip: tooltipProps })
    ) : (
      <IconWithTooltip
        name="attachment"
        tooltip={tooltipProps.tooltip}
        tooltipPosition={tooltipProps.position}
        {...rest}
      />
    )

    return (
      <React.Fragment>
        {React.cloneElement(Icon, {
          active: hasAttachments,
          onClick: this.openAttachmentDialog,
        })}
        <AttachmentUpload forNote={forNote} hideIcon triggerId={triggerId} />
      </React.Fragment>
    )
  }
}

AttachmentIcon.propTypes = {
  triggerId: PropTypes.string,
  icon: PropTypes.element,
}

AttachmentIcon.defaultProps = {
  triggerId: 'attachmentUploadTrigger',
  icon: null,
}

const select = state => ({
  hasAttachments: getLength(selectTicketDraftAttachments(state)) > 0,
})

export default connect(select)(AttachmentIcon)
